import React from 'react'
import { CircularProgress } from '@material-ui/core'

const CircularLoaderSong = () => {
  return <CircularProgress size={60} />
}

export default CircularLoaderSong
